import React from "react"
import { Box, Fade, Grid2, Typography } from "@mui/material"
import Logo from "./AnimatedLogo"
import { useAppBarHeight, useUseableHeight } from "../utils/styling"
import CircularProgress from "@mui/material/CircularProgress"

interface ILoadingProps {
    fullScreen?: boolean
}

interface ICircularProgressProps {
    progress: number
}

const fullScreenSx = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100%",
    zIndex: 1000,
    bgcolor: "background.paper",
}

export const Loading = (props: ILoadingProps) => {
    const height = useUseableHeight()
    const appBarHeight = useAppBarHeight()
    const normalSx = {
        bgcolor: "background.paper",
        height,
        width: "100vw",
        marginTop: appBarHeight,
    }

    return (
        <Box sx={props.fullScreen ? fullScreenSx : normalSx}>
            <Fade in={true} timeout={{ enter: 2000 }}>
                <Box
                    sx={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "white",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Logo />
                </Box>
            </Fade>
        </Box>
    )
}

export const CenterCircular = () => {
    return (
        <Grid2
            container
            justifyContent="center"
            alignItems="center"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: Semi-transparent background
                zIndex: 9999,
            }}
        >
            <CircularProgress color="primary" size={40} />
        </Grid2>
    )
}

function CircularProgressWithLabel({ progress = 0 }: ICircularProgressProps) {
    return (
        <Box sx={{ position: "relative", display: "inline-flex" }}>
            <CircularProgress variant="determinate" value={progress} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Typography
                    variant="caption"
                    component="div"
                    sx={{ color: "text.secondary" }}
                >{`${Math.round(progress)}%`}</Typography>
            </Box>
        </Box>
    )
}

export default function CircularWithValueLabel({ progress = 0 }: ICircularProgressProps) {
    return (
        <Grid2
            container
            justifyContent="center"
            alignItems="center"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 9999,
            }}
        >
            <CircularProgressWithLabel progress={progress} />
        </Grid2>
    )
}
